import { STATUS_ENUM } from '@/utils/geo'

export const defaultState = () => {
    return {
        lat: null,
        long: null,
        accuracy: null,
        time: null,
        error: null,
        status: STATUS_ENUM.NONE
    }
}

const state = defaultState()
export default state
